import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import { useCookies } from 'react-cookie';
import cookieName from '../../helpers/cookiesDeclaration';
import CircularProgress from '@material-ui/core/CircularProgress';

const useGeneralStyles = GeneralStyles;

function Terms() {
    const [terms, setTerms] = useState(null);
    const [loading, setLoading] = useState(false);
    const classesG = useGeneralStyles();

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/terms`)
            .then((response) => {
                setTerms(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, []);


    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {terms === null || terms === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{terms.Page_title}</title>
                                <meta name="description" content={terms.Page_description} />
                            </MetaTags>

                            <div className={classesG.container}>

                                <section className={classesG.section}>
                                    <div className={classesG.careersSecondSectionContent}>
                                        <div className={classesG.sectionBox}>
                                            <div className={classesG.termsfirstSectionText}>
                                                <h2>{terms.Title}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: terms.Content }} />
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <Box mt={7}></Box>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default Terms;
